import React from 'react';
import cx from 'classnames';

import ProductDetailPanel from '../../ProductDetailPanel';
import BaseForm from '../../../../../components/form/BaseForm';
import InputForm from '../../../../../components/form/InputForm';
import ButtonList from '../../../../../components/ButtonList';
import CheckboxGroup from '../../../../../components/input/CheckBoxGroup/CheckBoxGroup';
import useFormState from '../../../../../hooks/product/useFormState';
import { asyncSimpleModal } from '../../../../../lib/common';
import { compareProductVersion } from '../../../../../lib/utils';
import { PAY_METHOD_TYPE } from '../../../../../constants/service/app/orderConstants';
import {
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
  PRODUCT_PAY_CARD_OPTION_BUTTON_LIST,
  PRODUCT_PAY_METHOD_SELECT_LIST,
  PRODUCT_PAY_METHOD_TYPE_SELECT_LIST,
  PRODUCT_PAY_METHOD_VALUE_TYPE,
} from '../../../../../constants/service/app/productConstants';
import './ProductPayMethod.scss';

const ProductPayMethod = (props) => {
  const { isEditable, form, initialValue, productPayMethodTypeInfo, isCompare, comparisonData, ...res } = props;
  const [productPayMethodTypeId, setProductPayMethodTypeId] = useFormState(initialValue.productPayMethodTypeId, {
    form,
    key: 'productPayMethodTypeId',
  });
  const [productPayMethodList, setProductPayMethodList] = useFormState(initialValue.productPayMethodList, {
    form,
    key: 'productPayMethodList',
  });
  const [card, setCard] = useFormState(initialValue.card, { form, key: 'card' });
  const { isOption, optionList, feeInfo } = form.getFieldsValue();

  const onClickPayMethodButtonList = async ({ id }) => {
    const productPayMethodTypeId = id;
    const productPayMethodList = productPayMethodTypeInfo[id].list;
    const card = productPayMethodTypeInfo[id].card || PRODUCT_PAY_METHOD_VALUE_TYPE.UN_USED;

    /**
     *  가능한 결제수단 리스트
     */
    const isGift = isOption && optionList.length ? !!optionList.find((item) => item.isGift) : feeInfo.isGift;
    const availablePayMethodList = isGift
      ? productPayMethodList.filter((payMethodType) => payMethodType !== PAY_METHOD_TYPE.VBANK)
      : productPayMethodList;

    /**
     *  가능한 결제수단이 없는 경우
     */
    if (!availablePayMethodList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '안내',
        message: '결제가능한 수단이 없습니다.\n' + '상품 결제 타입을 바꾸거나, 선물 여부를 변경해주세요.',
      });
    } else {
      setProductPayMethodTypeId(productPayMethodTypeId);
      setProductPayMethodList(productPayMethodList);
      setCard(card);
    }
  };

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_PAY_METHOD}
      className="product-pay-method"
      title="상품 결제 정보"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        {/* 상품 결제 타입 */}
        <BaseForm
          className={isCompare && compareProductVersion(productPayMethodTypeId, comparisonData.productPayMethodTypeId)}
          label="상품 결제 타입"
          content={
            <ButtonList
              current={productPayMethodTypeId}
              list={PRODUCT_PAY_METHOD_TYPE_SELECT_LIST}
              onClick={onClickPayMethodButtonList}
              disabled={!isEditable}
            />
          }
          subContent={
            <span className="primary">
              *상품의 형태에 따라 결제 가능수단이 변경되므로 반드시 확인해주시기 바랍니다.
            </span>
          }
        />

        <BaseForm
          className={isCompare && compareProductVersion(productPayMethodList, comparisonData.productPayMethodList)}
          label="결제 가능 수단"
          content={<CheckboxGroup value={productPayMethodList} list={PRODUCT_PAY_METHOD_SELECT_LIST} disabled={true} />}
        />

        {card !== PRODUCT_PAY_METHOD_VALUE_TYPE.UN_USED ? (
          <BaseForm
            className={cx('card-option', isCompare && compareProductVersion(card, comparisonData.card))}
            label="카드 옵션"
            content={<ButtonList current={card} list={PRODUCT_PAY_CARD_OPTION_BUTTON_LIST} disabled={true} />}
            subContent={
              card === PRODUCT_PAY_METHOD_VALUE_TYPE.PART ? (
                <>
                  <div>일부 선택 시, 결제 가능한 카드사는 다음과 같습니다.</div>
                  <div className="primary">비씨, KB국민, 농협, 신한</div>
                </>
              ) : null
            }
          />
        ) : null}
      </div>
      <div className="hidden-form">
        <InputForm form={form} type="hidden" name="productPayMethodTypeId" initialValue={productPayMethodTypeId} />
        <InputForm form={form} type="hidden" name="productPayMethodList" initialValue={productPayMethodList} />
        <InputForm form={form} type="hidden" name="card" initialValue={card} />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductPayMethod;
